//Include Both Helper File with needed methods


import { getAnnexureDetails,  } from "../../../helpers/fakebackend_helper";

import {
  
  apiRequest,
  apiError,
 
  
} from "./reducer";

import { createAsyncThunk } from "@reduxjs/toolkit";


export const annexure_detailsThunk = createAsyncThunk("annexure_detailsThunk", async ({  token} ) => {
  try {
    
      const response = getAnnexureDetails(token);
      return response;
     
  } catch (error) {
      return error;
  }
});













